import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams, ToastController, AlertController } from 'ionic-angular'

import { AuthProvider } from '../../providers/auth/auth'
import { UserProvider } from '../../providers/user/user'
import { AccountProvider } from '../../providers/account/account'

import { UserEditPage } from '../user-edit/user-edit'

import { User, Account, AccountType } from '../../models/models'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-user-show',
	templateUrl: 'user-show.html',
})
export class UserShowPage {
	public user: User
	public isLoading: boolean = true;
	public isCondominiumExpanded: boolean = false;
	public isHousingUnitsExpanded: boolean = false;

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public get hasEmailPassword(): boolean {
		if(!this.user || !this.user.accounts || this.user.accounts.length == 0) {
			return false
		}

		for(let account of this.user.accounts) {
			if(account.type == AccountType.EMAIL_PASSWORD) {
				return true
			}
		}

		return false
	}


	public get hasPin(): boolean {
		if(!this.user || !this.user.accounts || this.user.accounts.length == 0) {
			return false
		}

		for(let account of this.user.accounts) {
			if(account.type == AccountType.PIN) {
				return true
			}
		}

		return false
	}

	constructor(
		private accounts: AccountProvider,
		private alertCtrl: AlertController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public auth: AuthProvider,
		public toastCtrl: ToastController,
		public users: UserProvider
	) {
		this.user = navParams.get('user')
	}

	goToUserEdit() {
		this.navCtrl.push(UserEditPage, { user: this.user })
	}

	/*
	Aggiorna i dati  prima di visualizzare
	*/
	ionViewWillEnter() {
		this.refresh()
	}

	public generatePin() {
		let self = this

		let alert = self.alertCtrl.create({
			title: 'Generare il PIN?',
			message: 'Vuoi generare un PIN e assegnarlo a questo utente?',
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel',
					handler: () => {}
				}, {
					text: 'Genera PIN',
					handler: () => {
						self.isLoading = true
						self.users.generatePin(self.user).then((pin: number) => {
							let toast = self.toastCtrl.create({
								message: "PIN generato: " + pin,
								position: 'middle',
								duration: 3000,
								cssClass: "success"
							})
							toast.present()
							self.refresh()
						})
					}
				}
			]
		})
		alert.present()
	}

	/**
	Invia il pin per email
	*/
	public sendPin(pin: string) {
		let self = this
		this.isLoading = true

		this.accounts.sendPin(+pin).then(() => {
			let toast = self.toastCtrl.create({
				message: "PIN inviato",
				position: 'middle',
				duration: 3000,
				cssClass: "success"
			})
			toast.present()
			this.isLoading = false
		}).catch(error => {
			let toast = self.toastCtrl.create({
				message: "Errore inviando il PIN per email",
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
			this.isLoading = false
		})
	}

	public createEmailPassword() {
		let self = this
		let alert = this.alertCtrl.create({
			title: 'Crea accesso con email e password',
			inputs: [
				{
					name: 'email',
					type: 'email',
					placeholder: 'Email',
					value: self.user.email
				},
				{
					name: 'password',
					placeholder: 'Password',
					type: 'password'
				},
				{
					name: 'password_confirm',
					placeholder: 'Conferma password',
					type: 'password'
				}
			],
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel',
					handler: data => {}
				},
				{
					text: 'Crea',
					handler: data => {
						if(data.password == data.password_confirm) {
							// ok
							let account: Account = {
								id: null,
								type: AccountType.EMAIL_PASSWORD,
								identifier: data.email,
								secret: data.password,
								user_id: self.user.id
							}

							self.accounts.store(account).then((account) => {
								if(account) {
									let toast = self.toastCtrl.create({
										message: "Account creato",
										position: 'middle',
										duration: 3000,
										cssClass: "success"
									})
									toast.present()
								} else {
									let toast = self.toastCtrl.create({
										message: "Impossibile creare questo login con email e password",
										position: 'middle',
										duration: 3000,
										cssClass: "danger"
									})
									toast.present()
								}
								self.refresh()
							}).catch(error => {
								let message = "Errore creando il login con email e password"
								if(error['errors'] && error['errors']['identifier']) {
									message = "Email non valida o già in uso"
								}

								let toast = self.toastCtrl.create({
									message: message,
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
								self.refresh()
							})
						} else {
							let toast = self.toastCtrl.create({
								message: 'La password non coincide, riprova',
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							})
							toast.present()
						}
					}
				}
			]
		})
		alert.present()
	}


	/*
	Rilettura dei dati
	*/
	private refresh() {
		this.isLoading = true
		let self = this

		this.users.getById(this.user.id, [
			'accounts',
			'condominiums',
			'condominiums.userRoles',
			'condominiums.housingUnits',
			'condominiums.housingUnits.userRoles',
			'housingUnits',
			'housingUnits.userRoles',
			'housingUnits.condominium',
			'housingUnits.condominium.userRoles'
		]).then(
			(user: User) => {
				self.user = user
				self.isLoading = false
				console.log('Utente letto: ', self.user)
			},
			(error) => {
				self.isLoading = false
				console.error("Errore recuperando i dati dell'utente:", error)
				let toast = self.toastCtrl.create({
					message: "Errore recuperando i dati dell'utente",
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/user-show/user-show.ts